export const meta = {
  title: 'Mulakan: daripada pendaftaran ke tiket pertama anda',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'pos', 'billing'],
};

Carwash anda boleh beroperasi sebelum kopi anda sejuk. Panduan ini membawa anda daripada borang pendaftaran sehingga tiket pertama anda selesai dikutip.

## 1. Daftar — 30 saat, tanpa kad

Pergi ke halaman **Daftar** dan isikan empat perkara: nama perniagaan, nama anda, e-mel, dan kata laluan. Jika ejen jualan memperkenalkan anda, kod mereka sama ada sudah tersedia pada pautan anda atau boleh ditaip sendiri — kod ini tidak sesekali mengubah harga yang anda bayar.

Sebaik dihantar, akaun anda terus aktif: **percubaan percuma 14 hari** dengan akses penuh, tanpa kad diperlukan. Anda terus log masuk dan tiba di papan pemuka anda.

## 2. Wizard aluan

Kali pertama anda membuka papan pemuka, wizard empat langkah menyediakan perkara asas:

1. **Sahkan outlet anda** — nama dan alamat, seperti yang patut dilihat pelanggan.
2. **Waktu operasi** — waktu buka dan tutup mingguan anda.
3. **Logo anda** — muat naik dan kami jana set ikon penuh untuk aplikasi pelanggan anda. Anda boleh langkau dan tambah kemudian melalui Branding, tetapi selagi belum, pelanggan akan nampak logo sementara.
4. **Kad aluan anda** — kiraan hari percubaan, pautan aplikasi pelanggan anda, dan butang **Buka giliran**.

Selesai, dan anda berada di papan giliran — skrin yang akan menjadi tumpuan pasukan anda setiap hari.

## 3. Letakkan QR anda di tempat pelanggan berdiri

Buka **Print QR** daripada pengepala papan giliran. Ia memberikan kod QR sedia cetak untuk outlet anda. Lekatkan di pintu masuk, di kaunter — di mana-mana pemandu menunggu.

Apabila pelanggan mengimbasnya, mereka membuka aplikasi web **anda** — nama anda, warna anda, logo anda. Mereka pilih pakej cucian, jenis kenderaan, taip nombor plat, dan masuk giliran. Tiada app store, tiada muat turun.

## 4. Tiket pertama anda

Sebaik pelanggan menempah, satu tiket muncul dalam lajur **Dalam giliran** di papan giliran anda dengan nombor tiket ringkas dan nombor plat mereka. Tiket baharu masuk di hujung barisan.

Gerakkan ia merentasi papan:

- Tekan **Mula** apabila kereta masuk ke ruang cucian — tiket pelanggan berpindah ke _Sedang dicuci_.
- Tekan **Siap** apabila cucian selesai — pelanggan menerima notifikasi bahawa kereta mereka sudah siap.
- Tiket kini menunggu dalam _Sedia untuk diambil_ sehingga pembayaran dibuat.

## 5. Terima bayaran di POS

Buka skrin **POS**. Setiap tiket yang sedia untuk diambil tersenarai di situ. Tekan tiket, pilih cara pelanggan membayar — tunai, DuitNow QR, TNG, GrabPay, kad, pindahan bank, baucar, atau percuma — dan sahkan. Tiket diarkibkan ke dalam sejarah dan mata kesetiaan pelanggan diberikan serta-merta.

Itulah kitaran penuh: imbas → giliran → cuci → siap → dibayar. Semua yang lain — kesetiaan, baucar, pemasaran — dibina di atas tiket-tiket ini.

## Seterusnya

Baca **Papan giliran** untuk susunan semula, tahan tiket, dan pertukaran outlet, serta **Pengebilan & langganan anda** untuk bagaimana percubaan bertukar kepada invois pertama anda.
